import $ from 'jquery';
window.addEventListener('px-ready',function(){
    /*$(window).on('resize',function(){
        $('.footer-spacer').css('height',$('.l-footer').outerHeight());
    })*/
})